import { useSyncExternalStore } from 'react';

const HOVER_QUERY = '(hover: hover)';

export function useIsDesktop() {
    return useSyncExternalStore(
        subscribeToHover,
        () => window.matchMedia(HOVER_QUERY).matches,
        () => false,
    );
}

function subscribeToHover(onChange: () => void) {
    const hoverMediaQuery = window.matchMedia(HOVER_QUERY);
    hoverMediaQuery.addEventListener('change', onChange);
    return () => hoverMediaQuery.removeEventListener('change', onChange);
}
